export const getAuthToken = () => {
  if (typeof window === 'undefined') return '';

  const params = new URLSearchParams(window.location.search);
  const urlToken = params.get('token');

  if (urlToken) {
    localStorage.setItem('token', urlToken);
    return urlToken;
  }

  return localStorage.getItem('token') || '';
};
